import React, { useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { Grid, Typography, Button } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';
import ShowProgress from '../ui/Backdrop';
import useFetchDealershipList from './hooks/useFetchDealershipList';
import DealershipListColumns from './DealershipListColumns';
import DealershipMetaModal from './components/DealershipMetaModal';
import DealershipListFilters from './DealershipListFilters';

const DealershipListTable = () => {
  const { dealershipList, rowCount, getList } = useFetchDealershipList();

  const [selectedDealership, setSelectedDealership] = useState(null);
  const [showMetaModal, setShowMetaModal] = useState(false);
  const [filters, setFilters] = useState({});

  const [tableState, setTableState] = useState({
    sorting: [],
    pagination: { pageIndex: 0, pageSize: 20 },
  });

  const filtersRef = useRef(filters);
  filtersRef.current = filters;

  useEffect(() => {
    const { pagination, sorting } = tableState;
    getList(pagination, sorting, filtersRef.current);
  }, [getList, tableState]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRefresh = () => {
    setFilters({});
    setTableState({ sorting: [], pagination: { pageIndex: 0, pageSize: 20 } });
  };

  const handleApplyFilters = (applied) => {
    setFilters(applied);
    setTableState((prev) => ({ ...prev, pagination: { ...prev.pagination, pageIndex: 0 } }));
    getList({ ...tableState.pagination, pageIndex: 0 }, tableState.sorting, applied);
  };

  const handleClearFilters = () => {
    setFilters({});
    setTableState((prev) => ({ ...prev, pagination: { ...prev.pagination, pageIndex: 0 } }));
    getList({ ...tableState.pagination, pageIndex: 0 }, tableState.sorting, {});
  };

  const handleOpenMeta = (row) => {
    setSelectedDealership(row);
    setShowMetaModal(true);
  };

  const handleCloseMeta = () => {
    setShowMetaModal(false);
    setSelectedDealership(null);
  };

  return (
    <Grid>
      <br />
      <Grid item>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Typography variant="h5" component="h2">
            Dealership List
          </Typography>
          <Button onClick={handleRefresh}>
            <Refresh />
          </Button>
        </Grid>
      </Grid>
      <br />
      <Grid item style={{ padding: '0 16px' }}>
        <DealershipListFilters onApply={handleApplyFilters} onClear={handleClearFilters} />
      </Grid>
      <Grid item>
        <MaterialReactTable
          columns={DealershipListColumns()}
          data={dealershipList}
          manualSorting
          manualPagination
          enableColumnFilters={false}
          enableGlobalFilter={false}
          onSortingChange={(sortFn) => {
            const sorting = sortFn(tableState.sorting);
            setTableState((prev) => ({ ...prev, sorting, pagination: { ...prev.pagination, pageIndex: 0 } }));
          }}
          onPaginationChange={(pageFn) => {
            const pagination = pageFn(tableState.pagination);
            setTableState((prev) => ({ ...prev, pagination }));
          }}
          rowCount={rowCount}
          state={{
            sorting: tableState.sorting,
            pagination: tableState.pagination,
          }}
          muiTableBodyRowProps={{ hover: true }}
          enableStickyHeader
          enableBottomToolbar
          enableTopToolbar={false}
          enableRowActions
          positionActionsColumn="last"
          renderRowActions={({ row: { original } }) => (
            <button
              type="button"
              onClick={() => handleOpenMeta(original)}
              style={{
                cursor: 'pointer',
                color: '#622FEE',
                textDecoration: 'underline',
                fontSize: '13px',
                background: 'none',
                border: 'none',
                padding: 0,
                fontFamily: 'inherit',
              }}
            >
              Meta
            </button>
          )}
        />
      </Grid>

      {showMetaModal && selectedDealership && (
        <DealershipMetaModal
          isOpen
          handleClose={handleCloseMeta}
          dealershipId={selectedDealership.dealershipId}
          dealershipName={selectedDealership.dealershipName}
          dealershipCode={selectedDealership.dealershipCode}
        />
      )}

      <ShowProgress />
    </Grid>
  );
};

export default DealershipListTable;
